import React from "react";
import { DoughnutChart } from "../../common/components/charts/doughnut"
import { ChartHelper } from "../../common/components/charts/chartsHelper";
import { Loading } from "../../common/components/loading";
import TopClimaReportStore from "../TopClimaReportStore";

export default () => {
    let items = TopClimaReportStore.useAll()
    if (!items)
        return <Loading />

    return <>
        <DoughnutChart
            key={new Date().valueOf()}
            title="TOP 5 GENERATORI CLIMA"
            labels={items.map(x => `${x.marca} ${x.modello}`)}
            data={items.map(x => x.tot)}
            colorscheme={4}
        />
        <div className="d-flex flex-wrap justify-content-center align-items-center mt-3" >
            {items.map((x, i) => <div key={`legend_${x.marca! + x.modello!}_${i}`}
                className="me-3 ps-2"
                style={{ borderLeft: `6px solid ${ChartHelper.getColorScheme(1)[i]}` }}>
                <div style={{ fontSize: "0.9rem" }}>
                    <div className="text-nowrap">{x.marca}</div>
                    <div className="text-nowrap">{x.modello}</div>
                </div>
                <div style={{ fontSize: "1.2rem" }} className="fw-bold">{x.tot}</div>
            </div>)}
        </div>
    </>
}